import { gql } from '@apollo/client'
import { useSubscription } from '@apollo/client/react'

export const LAB_TEST_WIDGET_SUBSCRIPTION = gql`
  fragment LabTestFields on DashboardLabTestEntry {
    orderDate
    patient {
      id
    }
    testLogs {
      id
      name
      statusId
      notes
      date
      labType
      labVendor
      businessId
    }
    vet {
      id
      firstName
      lastName
    }
    order {
      id
      externalId
      status {
        id
        name
      }
      date
      pdfUrl
      soap {
        id
      }
      iframeUrl
      notes
      orphan
      result {
        id
        pdfUrl
        externalId
        date
        iframeUrl
      }
    }
    vendor {
      id
      name
    }
    uniqueIdentifier
    soap {
      id
    }
    invoice {
      id
    }
    appointment {
      id
      scheduledStartDatetime
      businessAppointmentType {
        id
        name
      }
      businessId
    }
  }

  subscription LabTestWidget(
    $patientId: ID!
    $offset: PageOffset = 0
    $limit: PageLimit = 5
    $includeCompleted: Boolean = false
    $includeInProgress: Boolean = false
    $includeResultsReceived: Boolean = false
  ) {
    labTestWidget(patientId: $patientId, offset: $offset, limit: $limit) {
      completedLabTests @include(if: $includeCompleted) {
        ...LabTestFields
      }
      inProgressLabTests @include(if: $includeInProgress) {
        ...LabTestFields
      }
      resultsReceivedLabTests @include(if: $includeResultsReceived) {
        ...LabTestFields
      }
      labTestCounters {
        completedLabTests
        inProgressLabTests
        resultsReceivedLabTests
      }
    }
  }
`

export interface LabTestWidgetSubscriptionOptions {
  includeCompleted?: boolean
  includeInProgress?: boolean
  includeResultsReceived?: boolean
  limit?: number
  offset?: number
  patientId: string
}

export const useLabTestWidgetSubscription = ({
  patientId,
  offset = 0,
  limit = 5,
  includeCompleted = false,
  includeInProgress = false,
  includeResultsReceived = false,
}: LabTestWidgetSubscriptionOptions) =>
  useSubscription(LAB_TEST_WIDGET_SUBSCRIPTION, {
    variables: {
      patientId,
      offset,
      limit,
      includeCompleted,
      includeInProgress,
      includeResultsReceived,
    },
    skip: !patientId,
  })
